module.exports = __webpack_public_path__ + "static/img/cpfw-gyl.088bd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpfw-gyl.png
// module id = OjT3
// module chunks = 0